import React, { useState } from 'react'
import OrdersService from 'services/OrdersService'
import { OrderDetailsSuccessConfirmationModal } from 'components/Order/OrderSuccessConfirmationModal'
import AccountFormInput from '../../components/AccountFormInput'
import { toast } from 'react-toastify'

const BuyerInfoForm = ({ order }) => {
  const [saveLoading, setSaveLoading] = useState(false)
  const [buyerInfo, setBuyerInfo] = useState({
    name: order.name || '',
    personalId: order.personal_id || '',
    address: order.address || '',
  })
  const [response, setResponse] = useState({})
  const [confirmModal, setConfirmModal] = useState(false)

  const handleBuyerInfoChange = (field, value) => {
    setBuyerInfo(prev => ({ ...prev, [field]: value }))
  }

  const handleSaveBuyerInfo = async e => {
    e.preventDefault()
    if (
      !buyerInfo.name.trim() ||
      !buyerInfo.personalId.trim() ||
      !buyerInfo.address.trim()
    ) {
      return
    }

    setSaveLoading(true)
    const formData = new FormData()
    formData.append('order_id', order.id)
    formData.append('name', buyerInfo.name)
    formData.append('personal_id', buyerInfo.personalId)
    formData.append('address', buyerInfo.address)

    OrdersService.updateDetails(formData)
      .then(data => {
        if (data.next_step === 'confirm_number') {
          setResponse(data)
          setConfirmModal(true)
        } else {
          toast.success('ინფორმაცია წარმატებით განახლდა')
        }
      })
      .catch(() => {
        toast.error('განახლებისას მოხდა შეცდომა')
      })
      .finally(() => {
        setSaveLoading(false)
      })
  }

  const onOrderConfirm = () => {
    OrdersService.approveDetails({
      order_id: response.order_id,
      user_id: response.user_id,
      name: response.name,
      personal_id: response.personal_id,
      address: response.address,
    }).then(() => {
      setConfirmModal(false)
      toast.success('ინფორმაცია წარმატებით განახლდა')
    })
  }

  return (
    <>
      <OrderDetailsSuccessConfirmationModal
        onNumberConfirm={onOrderConfirm}
        show={confirmModal}
        response={response}
        onClose={() => setConfirmModal(false)}
      />
      <form onSubmit={handleSaveBuyerInfo}>
        <div className="mb-8 bg-slate-50/70 border border-slate-100 rounded-2xl p-4 sm:p-5">
          <div className="flex flex-col lg:flex-row gap-4">
            <AccountFormInput
              label="მყიდველის დასახელება"
              name="name"
              value={buyerInfo.name}
              onChange={e => handleBuyerInfoChange('name', e.target.value)}
              containerClassName="flex flex-col gap-2 flex-1"
              labelClassName="!text-[13px] !font-bold !text-slate-600 !mb-0"
            />
            <AccountFormInput
              label="პირადი ნომერი"
              name="personalId"
              value={buyerInfo.personalId}
              onChange={e =>
                handleBuyerInfoChange('personalId', e.target.value)
              }
              containerClassName="flex flex-col gap-2 flex-1"
              labelClassName="!text-[13px] !font-bold !text-slate-600 !mb-0"
            />
            <AccountFormInput
              label="მისამართი"
              name="address"
              value={buyerInfo.address}
              onChange={e => handleBuyerInfoChange('address', e.target.value)}
              containerClassName="flex flex-col gap-2 flex-[2]"
              labelClassName="!text-[13px] !font-bold !text-slate-600 !mb-0"
            />
            <div className="flex flex-col gap-2 justify-end">
              <div className="h-[21px] hidden lg:block"></div>
              <button
                type="submit"
                className={`px-5 py-3 w-full lg:w-auto ${
                  saveLoading
                    ? 'bg-slate-400 cursor-not-allowed'
                    : 'bg-citrus-red hover:bg-red-600 hover:-translate-y-0.5'
                } text-white border-none rounded-xl cursor-pointer text-[13px] font-medium transition-all duration-200 flex items-center gap-2 lg:whitespace-nowrap justify-center`}
                disabled={saveLoading}
              >
                {saveLoading ? 'ინახება...' : 'შენახვა'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default BuyerInfoForm
